import React, {useEffect} from 'react';
import {Route, Switch, useHistory, useParams} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import moment from 'moment';

import {loadOrderInfo} from '../redux/actions/orderActions';
import Header from './components/Header';
import {getImageUrl} from '../api/iposApi';
import OrderInfoPage from '../pages/order_info/OrderInfoPage';
import {setGeneralErrorTranslationKey} from '../redux/actions/baseActions';
import {convertDotNetTimeToMomentDate} from '../helpers/dateTime';

function OrderInfoLayout({loadOrderInfo, currentLanguageId, branchInfo, setGeneralErrorTranslationKey}) {
  const {branchId, orderId} = useParams();
  const history = useHistory();

  const fetchData = async () => {
    const res = await loadOrderInfo(branchId, orderId, currentLanguageId);

    if (res && res.order.close_time_dt){
      const orderCloseDate = convertDotNetTimeToMomentDate(res.order.close_time_dt);

      if (moment().diff(orderCloseDate, 'days') > 20){
        setGeneralErrorTranslationKey('order_info.link_expired');
        history.push(`/${branchId}/error`);
        return;
      }
    }

    if (!res || (res && (res.error_message || res == ''))) {
      setGeneralErrorTranslationKey('order_info.no_content_error');
      history.push(`/${branchId}/error`);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentLanguageId]);

  return (
    <>
      <div
        className={ 'restaurant-layout' }
        id={ 'scrollable-restaurant-layout' }
        style={ {
          backgroundImage: `url(${getImageUrl(branchInfo.BannerImageName)})`
        } }
      >
        {/* <div className={ 'mobile-header' }>
          &nbsp;
        </div>
        <Header /> */}

        <Switch>
          <Route exact path="/:branchId/order_info/:orderId" component={ OrderInfoPage } />
        </Switch>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  const {
    currentLanguageId,
    branchInfo
  } = state;

  return {
    currentLanguageId,
    branchInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadOrderInfo,
      setGeneralErrorTranslationKey
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(OrderInfoLayout);
